import {
  euCountries,
  euCountriesExceptPt,
  memberStates,
  memberStatesExceptPt,
  nonEuCountries,
  onlyPtCountryList,
  peculiarCountries,
  artificialCodeAddress
} from './countries';

function selectOptCmp(o1: {label: string}, o2: {label: string}) {
  return o1.label.localeCompare(o2.label);
}

export const euCountriesExceptPtOptions = euCountriesExceptPt
  .map(({codeA2, labelEN}) => ({value: codeA2, code: codeA2, label: labelEN}))
  .sort(selectOptCmp);
export const onlyPtCountryOptions = onlyPtCountryList
  .map(({codeA2, labelEN}) => ({value: codeA2, code: codeA2, label: labelEN}))
  .sort(selectOptCmp);

export const nonEuCountriesOptions = nonEuCountries
  .map(({codeA2, labelEN}) => ({value: codeA2, code: codeA2, label: labelEN}))
  .sort(selectOptCmp);
export const euCountriesOptions = euCountries
  .map(({codeA2, labelEN}) => ({value: codeA2, code: codeA2, label: labelEN}))
  .sort(selectOptCmp);

export const memberStatesOptions = memberStates
  .map(({codeA2, labelEN}) => ({value: codeA2, code: codeA2, label: labelEN}))
  .sort(selectOptCmp);
export const memberStatesExceptPtOptions = memberStatesExceptPt
  .map(({codeA2, labelEN}) => ({value: codeA2, code: codeA2, label: labelEN}))
  .sort(selectOptCmp);



export const peculiarCountriesOptions = function (countryA2, excludeArtificialCountryCodes ) {
  return peculiarCountries
    .filter(pc => pc.parentA2 == countryA2 && (!excludeArtificialCountryCodes || !artificialCodeAddress.includes(pc.codeA2)))
    .map(({codeA2, labelEN}) => ({value: codeA2, code: codeA2, label: labelEN}))
    .sort(selectOptCmp);
}


export const allCountriesOptions = [...euCountriesOptions, ...nonEuCountriesOptions];

export const euCountriesExceptPtCodeOptions = euCountriesExceptPtOptions
  .map(({value, label}) => ({value, label: `${value} - ${label}`}));
export const onlyPtCountryCodeOptions = onlyPtCountryOptions
  .map(({value, label}) => ({value, label: `${value} - ${label}`}));
export const nonEuCountriesCodeOptions = nonEuCountriesOptions
  .map(({value, label}) => ({value, label: `${value} - ${label}`}));
export const euCountriesCodeOptions = euCountriesOptions
  .map(({value, label}) => ({value, label: `${value} - ${label}`}));
export const allCountriesCodeOptions = allCountriesOptions
  .map(({value, label}) => ({value, label: `${value} - ${label}`}));
export const allCountriesCodeOnlyOptions = allCountriesOptions
  .map(({value, label}) => ({value, label: `${value} - ${label}`}));

export const memberStatesCodeOptions = memberStatesOptions
  .map(({value, label}) => ({value, label: `${value} - ${label}`}));
export const memberStatesExceptPtCodeOptions = memberStatesExceptPtOptions
  .map(({value, label}) => ({value, label: `${value} - ${label}`}));


export const nonEuCountriesAndPtOptions = [...onlyPtCountryOptions, ...nonEuCountriesOptions];
export const nonEuCountriesAndPtCodeOptions = nonEuCountriesAndPtOptions
  .map(({value}) => ({value, label: value}));

export const allCountriesCodeOptionsWithoutArtificialCodes = allCountriesCodeOptions.filter(country => !artificialCodeAddress.includes(country.value));

export const peculiarCountriesCodeOptions = function (countryA2, isReadOnly) {
  return peculiarCountriesOptions(countryA2, isReadOnly)
    .map(({value, label}) => ({value, label: `${value} - ${label}`}));
}
